import validation from '../../../../../../modules/Gull/Framework/validation.js';

const uitvraag = {

	init() {

		// Toon en verbeg kvk upload
		$('[name=gelieerdeOndernemingen]').on('change', function() {
			var t = $('[name=kvkUittreksel]');
			var g = t.closest('.form-group');
			validation.addRequired(t);
			g.removeClass('d-none');
			if ($(this).val() == 'n') {
				validation.removeRequired(t);
				g.addClass('d-none');
			}
		});

		// Toon bevestigings modal na submit
		$('form[data-validate]').attr('data-validate-onsubmit-disabled', true);
		$('form[data-validate]').submit(async function() {
			let validated = await validation.checkSubmitForm(this);
			if (validated) {
				$('#modalBevestigen').modal('show');
				$('.btn-submit-confirm').click(function() {
					$('form[data-validate]').unbind('submit');
					$('form[data-validate]').submit();
				});
			}
			return false;
		});

	},

};

export default uitvraag;
